import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from '../http.service';
import { BaseService } from '../base/base.service';
import { BarChartDate } from '../../models';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseChartService<T> extends BaseService {
  protected constructor(
    protected baseRoute: string,
    protected httpService: HttpService,
  ) {
    super(baseRoute, httpService);
  }

  get(model: BarChartDate): Observable<T[]> {
    return this.httpService.get<T[]>(
      `${this.apiUrl}?date=${model.date.toISOString()}&period=${model.period}&productId=${model.productId}&id=${
        model.id
      }`,
    );
  }
}
